
export const images = [
    {
        src: "gallery/blue-divider-1.jpg",
        
    },
    {
        src: "gallery/engagement-4.jpg",
        
    },
    {
        src: "gallery/blue-divider-2.jpg",
        
    },
    {
        src: "gallery/reception-1.jpg",
        
    },
    {
        src: "gallery/staircase-1.jpg",
        
    },
    {
        src: "gallery/engagement-3.jpg",
        
    },
    {
        src: "gallery/Collab-4.jpg"
    },
    {
        src: "gallery/Collab-PinkSuit-32.jpg",
        
    },
    {
        src: "gallery/engagement-5.jpg",
        
    },
    {
        src: "gallery/Collab-PinkSuit-33.jpg",
        
    },
    {
        src: "gallery/Collab-PinkSuit-19.jpg",
        
    },
    {
        src: "gallery/engagement-1.jpg",
        
    },
    {
        src: "gallery/engagement-2.jpg",
        
    },
    {
        src: "gallery/purple-backdrop.jpg",
    }
    ,
    {
        src: "gallery/pink-divider.jpg",
    },
    {
        src: "gallery/white-divider.jpg",
    },
    {
        src: "gallery/blue-divider-3.jpg",
        
    },
    {
        src: "gallery/blue-divider-4.jpg",
        
    },
    {
        src: "gallery/purple-backdrop.jpg",
    }
    

    
]
